package music.jammers.client.shared.component.card.info.di

import music.jammers.client.shared.component.card.info.presentation.viewmodel.CardInfoViewModel
import music.jammers.client.shared.event.data.repository.CardInfoRepositoryImpl
import music.jammers.client.shared.event.domain.repository.CardInfoRepository
import music.jammers.client.shared.event.domain.usecase.GetCardInfoUseCase
import org.koin.core.component.KoinComponent
import org.koin.dsl.module

val cardInfoModule = module {

    factory {
        CardInfoViewModel(
            getCardInfoUseCase = get(),
        )
    }

    single {
        GetCardInfoUseCase(
            cardInfoRepository = get(),
        )
    }

    single<CardInfoRepository> {
        CardInfoRepositoryImpl(
            httpClient = get(),
        )
    }
}

class CardInfoDIComponent : KoinComponent {

    val viewModel: CardInfoViewModel
        get() = getKoin().get<CardInfoViewModel>()
}